import PropTypes from 'prop-types';

import styles from './_index.module.scss';

const Summary = ({ aiSummary }) => {
  return (
    <div className={styles['summary']} data-testid="video-summary-container">
      <h3>AI Summary</h3>
      <div className={styles['summary-content']}>
        {aiSummary ? (
          <p data-testid="video-summary-text">{aiSummary}</p>
        ) : (
          <p className={styles['summary-no-content']} data-testid="video-summary-empty-message">
            No summary available
          </p>
        )}
      </div>
    </div>
  );
};

Summary.propTypes = {
  aiSummary: PropTypes.string,
};

export default Summary;
